export default __webpack_public_path__ + "static/media/ooredoo.c5eec5c8.png";